"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function NetworkDecentral(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M12 2a2 2 0 0 0-1.994 1.879L5.102 6.332A2 2 0 1 0 4 10c.392 0 .773-.116 1.1-.332l4.906 2.453c.041.669.414 1.273.994 1.608v4.54l-.102.063-4.904-2.453A2 2 0 0 0 4 13.999a2 2 0 0 0 0 4c.392 0 .773-.115 1.1-.331l4.906 2.453A2 2 0 0 0 12 22a2 2 0 0 0 1.994-1.881l4.904-2.451A2 2 0 1 0 20 14a2 2 0 0 0-1.994 1.879l-4.904 2.453L13 18.27v-4.542c.58-.335.953-.94.994-1.608l4.904-2.453A2 2 0 1 0 20 6a2 2 0 0 0-1.994 1.879L13.1 10.332A2.001 2.001 0 0 0 12 10a2.01 2.01 0 0 0-1.102.332L6.236 8l4.662-2.332A2 2 0 1 0 12 2", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = NetworkDecentral;
